import React, { useState } from 'react'

import { Button, Col, Form, Input, Modal, Row, Typography } from 'antd'

import CustomMap from '../CustomMap/customMap'
const { Text } = Typography

export default function GpsMaping(props) {
  const { field, value, name, errors, setFieldValue, required, disabled } = props
  const [mapLatitude, setMapLatitude] = useState(undefined)
  const [address, setAddress] = useState(undefined)
  const [mapLongitude, setMapLongitude] = useState(undefined)
  const [, setMapZoom] = useState(undefined)
  const [cepModal, setCepModal] = useState(false)
  const [cepValue, setCepValue] = useState('')
  const [cepLoading, setCepLoading] = useState(false)
  const [cepError, setCepError] = useState('')

  const getValidCoordinate = (num) => (isNaN(num) ? 0 : num)

  const onLatLongChange = (valueData) => {
    if (valueData.mapLatitude !== mapLatitude || valueData.mapLongitude !== mapLongitude) {
      setAddress('')
      updatedValueFieldOnSubmitForm(
        getValidCoordinate(valueData.mapLatitude),
        getValidCoordinate(valueData.mapLongitude),
        ''
      )
    }
  }

  const updatedValueFieldOnSubmitForm = (lat, long, address) => {
    setFieldValue(
      name,
      JSON.stringify({
        lat,
        long,
        address
      })
    )
  }

  const showMessageError = () => {
    const errorsOnFields = Object.keys(errors)
    if (errorsOnFields.length > 0 && errorsOnFields.includes(name)) {
      const msgError = errors[name]
      return (
        <Col span={24} style={{ marginTop: 5, marginBottom: 10 }}>
          <Text type="danger">{msgError}</Text>
        </Col>
      )
    } else {
      return null
    }
  }

  const requiredField = (marginLeft) => {
    if (required) {
      return (
        <Text
          className="required-asterisk"
          style={{ position: 'absolute', top: 8, marginLeft: marginLeft, color: 'red' }}
        >
          *
        </Text>
      )
    } else {
      return null
    }
  }

  function openCepModal() {
    setCepValue('')
    setCepError('')
    setCepModal(true)
  }

  function closeCepModal() {
    setCepModal(false)
    setCepValue('')
    setCepError('')
  }

  async function handleCepSearch() {
    const digits = cepValue.replace(/\D/g, '')
    if (digits.length !== 8) {
      setCepError('Digite um CEP válido com 8 dígitos.')
      return
    }
    setCepLoading(true)
    setCepError('')
    try {
      const response = await fetch(`https://brasilapi.com.br/api/cep/v2/${digits}`)
      if (!response.ok) {
        setCepError('CEP não encontrado.')
        return
      }
      const data = await response.json()
      let lat = data?.location?.coordinates?.latitude
      let lng = data?.location?.coordinates?.longitude

      const fullAddress = [data.street, data.city, data.state].filter(Boolean).join(', ')

      if (!lat || !lng) {
        const query = encodeURIComponent(fullAddress || `${digits}, Brasil`)
        const nominatimRes = await fetch(`https://nominatim.openstreetmap.org/search?q=${query}&format=json&limit=1`, {
          headers: { 'Accept-Language': 'pt-BR' }
        })
        const nominatimData = await nominatimRes.json()
        if (nominatimData?.[0]?.lat && nominatimData?.[0]?.lon) {
          lat = nominatimData[0].lat
          lng = nominatimData[0].lon
        } else {
          setCepError('Coordenadas não disponíveis para este CEP. Posicione o pin manualmente no mapa.')
          return
        }
      }

      setMapLatitude(String(lat))
      setMapLongitude(String(lng))
      setAddress(fullAddress)
      updatedValueFieldOnSubmitForm(getValidCoordinate(lat), getValidCoordinate(lng), fullAddress)
      closeCepModal()
    } catch {
      setCepError('Erro ao buscar o CEP. Tente novamente.')
    } finally {
      setCepLoading(false)
    }
  }

  React.useEffect(() => {
    if (value && value[name]) {
      const val = JSON.parse(value[name])
      setAddress(val.address)
      setMapLatitude(val.lat)
      setMapLongitude(val.long)
    }
  }, [value])

  return (
    <>
      <Modal
        title="Preencher via CEP"
        visible={cepModal}
        onCancel={closeCepModal}
        okText="Buscar"
        cancelText="Cancelar"
        confirmLoading={cepLoading}
        onOk={handleCepSearch}
        destroyOnClose
      >
        <Form.Item validateStatus={cepError ? 'error' : ''} help={cepError} label="CEP">
          <Input
            placeholder="00000-000"
            maxLength={9}
            value={cepValue}
            onChange={(e) => {
              setCepError('')
              setCepValue(e.target.value)
            }}
            onPressEnter={handleCepSearch}
            autoFocus
          />
        </Form.Item>
      </Modal>
      <Row type="flex">
        <Col span={4}>
          <Text className="ant-col ant-form-item-label">Latitude</Text>
          {requiredField(45)}
          <Form.Item validateStatus={errors[field] ? 'error' : 'validating'} help={errors[field]}>
            <Input
              id={props.id}
              disabled={disabled}
              value={mapLatitude}
              onChange={(e) => {
                const latitude = e.target.value.replace(/[a-zA-Z]+/g, '')
                setMapLatitude(latitude)
                updatedValueFieldOnSubmitForm(latitude, mapLongitude, address)
              }}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Text className="ant-col ant-form-item-label">Longitude</Text>
          {requiredField(55)}
          <Form.Item validateStatus={errors[field] ? 'error' : 'validating'} help={errors[field]}>
            <Input
              value={mapLongitude}
              disabled={disabled}
              onChange={(e) => {
                const longitude = e.target.value.replace(/[a-zA-Z]+/g, '')
                setMapLongitude(longitude)
                updatedValueFieldOnSubmitForm(mapLatitude, longitude, address)
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Endereço" validateStatus={errors[field] ? 'error' : 'validating'} help={errors[field]}>
            <Input
              value={address}
              disabled={disabled}
              onChange={(e) => {
                setAddress(e.target.value)
                updatedValueFieldOnSubmitForm(mapLatitude, mapLongitude, e.target.value)
              }}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Button
            disabled={disabled}
            onClick={openCepModal}
            style={{ marginTop: 22, color: '#843EF7', borderColor: '#B58BFA' }}
          >
            Preencher via CEP
          </Button>
        </Col>
        <Col span={24}>
          <Row type="flex" justify="start">
            <CustomMap
              disabled={disabled}
              latitude={getValidCoordinate(mapLatitude)}
              longitude={getValidCoordinate(mapLongitude)}
              zoom={8}
              setMapLatitude={setMapLatitude}
              setMapLongitude={setMapLongitude}
              setMapZoom={setMapZoom}
              callbackData={onLatLongChange}
            />
          </Row>
        </Col>
        {showMessageError()}
      </Row>
    </>
  )
}
